<template>
  <div
    class="relative size-full bg-gray-light flex items-center justify-center aspect-[1/1]"
  >
    <video
      v-if="videoUrl"
      ref="videoEl"
      class="size-full object-cover aspect-[1/1]"
      autoplay
      loop
      muted
      playsinline
      preload="auto"
    >
      <source :src="videoUrl" type="video/mp4" />
    </video>
  </div>
</template>

<script lang="ts" setup>
import type { MediaVideoFragment } from '#graphql-operations'

const props = defineProps<{
  video: MediaVideoFragment
}>()

const videoUrl = computed(() => props.video?.video?.entity?.fileUrl)

const videoEl = ref<HTMLVideoElement | null>(null)

onMounted(() => {
  if (videoEl.value) {
    videoEl.value.muted = true
    videoEl.value.play().catch(() => {})
  }
})
</script>
